import { Component, Input, OnInit } from '@angular/core';
import { OwnerCo } from '@model/syndic/owner-co';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { OwnerCoService } from '@service/syndic/owner-co.service';
import { SyndicService } from '@service/syndic/syndic.service';
import { Globals } from '@theme/utils/globals';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { OwnerCoAddComponent } from '../owner-co-add/owner-co-add.component';
import { OwnerCoShowComponent } from '../owner-co-show/owner-co-show.component';

@Component({
  selector: 'app-owner-co-list',
  templateUrl: './owner-co-list.component.html',
  styleUrls: ['./owner-co-list.component.scss']
})
export class OwnerCoListComponent implements OnInit {

  @Input() ownersCo: OwnerCo[] = [];
  @Input() trusteeUuid: string = '';
  dtOptions: any = {};

  constructor(
    private modalService: NgbModal,
    private emitter: EmitterService,
    private ownerCoService: OwnerCoService,
    private syndicService: SyndicService
  ) {
    this.emitter.event.subscribe((data: any) => {
      if (data.action === 'OWNERCO_ADD' || data.action === 'OWNERCO_UPDATED') {
        this.loadData();
      }
    });
  }

  ngOnInit(): void {
    this.dtOptions = Globals.dataTable;
    this.loadData();
  }

  loadData(): void {
    if (this.trusteeUuid) {
      this.ownerCoService.getList(this.trusteeUuid).subscribe((res: any) => {
        this.ownersCo = res || [];
      });
    }
  }

  addOwnerCo(): void {
    this.ownerCoService.edit = false;
    this.ownerCoService.setOwnerCo(null);
    this.ownerCoService.uuidSyndic = this.trusteeUuid;
    this.modal(OwnerCoAddComponent, 'modal-basic-title', 'lg');
  }

  editOwnerCo(row: OwnerCo): void {
    this.ownerCoService.edit = true;
    this.ownerCoService.setOwnerCo(row);
    this.modal(OwnerCoAddComponent, 'modal-basic-title', 'lg');
  }

  showOwnerCo(row: OwnerCo): void {
    this.ownerCoService.setOwnerCo(row);
    this.modal(OwnerCoShowComponent, 'modal-basic-title', 'xl');
  }

  deleteOwnerCo(item: OwnerCo): void {
    Swal.fire({
      title: 'Êtes-vous sûr ?',
      text: 'Cette action est irréversible !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, supprimer !',
      cancelButtonText: 'Non, annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.ownerCoService.getDelete(item.uuid).subscribe((res: any) => {
          if (res?.status === 'success') {
            this.loadData();
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        });
      }
    });
  }

  modal(component: any, type: string, size: string): void {
    const modalRef = this.modalService.open(component, {
      ariaLabelledBy: type,
      size: size,
      centered: true,
      backdrop: 'static'
    });
    modalRef.result.then((result) => {}, (reason) => {});
  }
}
